"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operators = exports.BehaviorSubject = void 0;
/** simplify version of rxjs */
var events_1 = require("events");
var BehaviorSubject = /** @class */ (function () {
    function BehaviorSubject() {
        var _this = this;
        this.debugName = '';
        this.event = new events_1.EventEmitter();
        this.isComplete = false;
        this.index = 0;
        this.complete = function () {
            _this.isComplete = true;
            _this.event.removeAllListeners('next');
            _this.event.emit('complete', _this.currentValue);
            _this.event.removeAllListeners('complete');
        };
        this.onComplete = function (fn) {
            var complete = function () {
                fn(_this.currentValue);
                _this.event.removeListener('complete', fn);
            };
            _this.event.on('complete', complete);
            return function () { return _this.event.removeListener('complete', complete); };
        };
        this.unsubscribe = function () {
            _this.event.removeAllListeners('next');
        };
        this.check = function () {
            if (_this.isComplete)
                throw new Error('Subject is Completed');
        };
        this.event.setMaxListeners(20);
    }
    BehaviorSubject.prototype.subscribe = function (listener) {
        var _this = this;
        this.check();
        if (typeof listener === 'function') {
            this.event.on('next', listener);
            return {
                unsubscribe: function () { return _this.event.removeListener('next', listener); },
                isComplete: this.isComplete,
            };
        }
        if (isSubject(listener)) {
            var unListenComplete_1 = this.onComplete(function () { return listener.complete(); });
            var sub$_1 = this.subscribe(function (val) { return listener.next(val); });
            var unsubscribe = function () {
                sub$_1.unsubscribe();
                unListenComplete_1();
            };
            listener.onComplete(unsubscribe);
            return {
                unsubscribe: unsubscribe,
                isComplete: listener.isComplete,
            };
        }
        return this;
    };
    BehaviorSubject.prototype.pipe = function () {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        this.check();
        var i = 0;
        // eslint-disable-next-line
        var root = this;
        var curSubject = root;
        while (i < operators.length) {
            var nextSubject = operators[i];
            var s$ = curSubject.subscribe(nextSubject);
            // in pipe line, anyone completed should destroy all pipe node to free memory
            nextSubject.onComplete((function (s, s2) { return function () {
                s.unsubscribe();
                s2 !== root && s2.complete();
            }; })(s$, curSubject));
            curSubject = operators[i];
            i += 1;
        }
        return curSubject;
    };
    BehaviorSubject.prototype.next = function (val) {
        this.check();
        this.currentValue = val;
        this.index += 1;
        this.event.emit('next', val);
    };
    BehaviorSubject.fromEvent = function (event, eventName) {
        var subject = new BehaviorSubject();
        event.on(eventName, function (val) {
            subject.next(val);
        });
        return subject;
    };
    return BehaviorSubject;
}());
exports.BehaviorSubject = BehaviorSubject;
var isSubject = function (obj) {
    if (!obj)
        return false;
    return obj instanceof BehaviorSubject || typeof obj.subscribe === 'function';
};
var OperatorSubject = /** @class */ (function (_super) {
    __extends(OperatorSubject, _super);
    function OperatorSubject(onNext, debugName) {
        var _this = _super.call(this) || this;
        _this.onNext = onNext;
        _this.debugName = debugName;
        return _this;
    }
    OperatorSubject.prototype.sendNext = function (val) {
        _super.prototype.next.call(this, val);
    };
    // @ts-ignore
    OperatorSubject.prototype.next = function (val) {
        if (this.isComplete)
            return;
        this.onNext(val, this);
    };
    OperatorSubject.create = function (onNext, debugName) { return new OperatorSubject(onNext, debugName); };
    return OperatorSubject;
}(BehaviorSubject));
var map = function (fn) { return OperatorSubject.create(function (val, sub) {
    sub.sendNext(fn(val));
}, 'map'); };
var filter = function (fn) { return OperatorSubject.create(function (val, sub) {
    if (fn(val)) {
        sub.sendNext(val);
    }
}, 'filter'); };
var take = function (n) { return OperatorSubject.create(function (val, sub) {
    sub.sendNext(val);
    if (sub.index >= n) {
        sub.complete();
    }
}, 'take'); };
/** 除抖动,除非数据发生变化 */
var debounceTimeUnlessChanged = function (n) {
    var timer = 0;
    return OperatorSubject.create(function (val, sub) {
        timer && window.clearTimeout(timer);
        timer = window.setTimeout(function () {
            sub.next(val);
        }, n);
    }, 'debounceTimeUnlessChanged');
};
/** skip if return true */
var debounceUtilChange = function (compare) {
    if (compare === void 0) { compare = function (a, b) { return a === b; }; }
    return OperatorSubject.create(function (val, sub) {
        var _a;
        if (typeof compare === 'string') {
            if (((_a = sub.currentValue) === null || _a === void 0 ? void 0 : _a[compare]) === val[compare]) {
                return;
            }
        }
        else if (typeof compare === 'function' && compare(sub.currentValue, val)) {
            return;
        }
        else if (sub.currentValue === val) {
            return;
        }
        sub.sendNext(val);
    }, 'debounceUtilChange');
};
exports.operators = {
    map: map,
    filter: filter,
    take: take,
    debounceUtilChange: debounceUtilChange,
    debounceTimeUnlessChanged: debounceTimeUnlessChanged,
};
